import { ComponentType } from 'react';
import { DropdownMenuOption } from '@ardoq/dropdown-menu-ui';
import { OptionProps } from 'react-select';
import { CommonSelectProps, SelectOption } from '../../types';
import { selectOptionOperations } from '../../selectOptionsOperations';

export const Option: ComponentType<
  OptionProps<SelectOption<unknown>> & {
    selectProps: Pick<
      CommonSelectProps,
      'keepRightContentActive' | 'hideSelectedOptions'
    >;
  }
> = ({
  isMulti,
  innerProps,
  innerRef,
  label,
  isFocused,
  isDisabled,
  isSelected,
  selectProps,
  data,
}) => {
  const {
    leftContent,
    rightContent,
    rightLabel,
    description,
    popoverContent,
    popoverPlacement,
    breadcrumbs,
    customData,
    isAi,
  } = data;
  const popoverProps = popoverContent
    ? { content: popoverContent, preferredPlacement: popoverPlacement }
    : undefined;

  const leftIcon = selectOptionOperations.getIconProps(data, 'left');
  const rightIcon = selectOptionOperations.getIconProps(data, 'right');

  return (
    <DropdownMenuOption
      ref={innerRef}
      isChecked={!isMulti ? undefined : isSelected || false}
      label={label}
      rightLabel={rightLabel}
      isDisabled={isDisabled}
      isFocused={isFocused}
      // React select controls the hover state of
      // option programmatically
      isHovered={isFocused}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      isSelected={!isMulti && isSelected}
      leftContent={leftContent}
      rightContent={rightContent}
      description={description}
      breadcrumbs={breadcrumbs}
      popoverProps={popoverProps}
      menuOptionWrapperProps={innerProps}
      keepRightContentActive={selectProps.keepRightContentActive}
      hideSelectedOptions={selectProps.hideSelectedOptions}
      customData={customData}
      isAi={isAi}
    />
  );
};
